export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
            <p className="text-sm text-foreground-600 mt-1">意见反馈 · 内容投稿 · 商务合作</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-500/15 mb-3">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">意见反馈</h3>
                <p className="text-xs text-foreground-600">
                  如遇播放问题或有功能建议，欢迎通过邮件反馈，我们会及时处理。
                </p>
                <a href="#contact" className="inline-block mt-2 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  feedback@renrencinema.com
                </a>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-500/15 mb-3">
                  <i className="ri-upload-cloud-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-600">
                  欢迎影视创作者投稿原创内容，优秀作品将获得首页推荐位展示。
                </p>
                <a href="#contact" className="inline-block mt-2 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  submit@renrencinema.com
                </a>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-500/15 mb-3">
                  <i className="ri-service-line text-secondary-500 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-600">
                  广告投放、版权合作、品牌联名等商务合作洽谈，请通过以下方式联系。
                </p>
                <a href="#contact" className="inline-block mt-2 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  biz@renrencinema.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}